export default {
    components: {
        TheLocaleSwitcher: {
            locales: {
                de: 'deutsch',
                en: 'english',
            },
            toast: 'Language changed',
        },
        TheHeader: {
            viewNotifications: 'View notifications',
            goToInbox: 'To Inbox',
            noNews: 'No new notifications',
        },
    },
    pages: {
        DashboardPage: {
            title: 'Dashboard',
            statusTeaser: {
                title: 'Statuspage',
                content: 'Information on future and ongoing maintenance.',
                action: 'Open page',
            },
            helpTeaser: {
                title: 'Knowledge base',
                content: 'Further information and answers to frequently asked questions.',
                action: 'Open page',
            },
            smokePingTeaser: {
                title: 'SmokePing',
                content: 'Check the latency of our network and measure its performance.',
                action: 'Open page',
            },
            contactTeaser: {
                title: 'Contacts',
                phone: 'Phone',
                mail: 'Mail',
                emergency: 'Emergency',
            },
            serviceTeaser: {
                title: 'Business hours',
                mondayToThursday: 'Mon-Thu:',
                mondayToThursdayOpeningHours: '08:00 am – 05:00 pm',
                friday: 'Fri:',
                fridayOpeningHours: '08:00 am – 03:30 pm',
                info: 'All times are in German local time ({timeZone} [{utcDifference}]).',
            },
            newsPostsSection: {
                title: 'Recent @.lower:pages.NewsPostIndexPage.title',
            },
            ticketSection: {
                title: 'Open tickets',
            },
            helpfulLinksSection: {
                title: 'Helpful links',
            },
        },
        CustomerPage: {
            title: 'Customer data',
            breadcrumb: '@:pages.CustomerPage.title',
            contactSection: {
                inactiveSwitch: 'Deactivated @.lower:resources.contact.name',
            },
        },
        ContactPage: {
            breadcrumb: '@:resources.contact.name',
            rolesSection: {
                title: '@:resources.contact.attributes.roles',
                description: 'Each role has one or more permissions.',
                tooltip: {
                    grantedPermissions: 'The holder of this role has the following permissions:',
                    ownerCannotBeTransferred:
                        'This role can only be transferred by a 23M employee.',
                    canOnlySetByOwner: 'This role can only be set by the owner.',
                },
            },
            permissionsSection: {
                title: '@:resources.contact.attributes.permissions',
                description: 'Each permission allows access to specific functions or data.',
                tooltip: {
                    grantedByRoles: 'The following active roles grant this permission:',
                    cannotBeRevoked:
                        'This permission can be revoked by removing the corresponding roles.',
                },
            },
        },
        OrderIndexPage: {
            title: 'Orders',
            breadcrumb: '@:pages.OrderIndexPage.title',
            badge: {
                description: 'There is {count} new offer | There are {count} new offers',
            },
        },
        OrderPage: {
            title: 'Order: {number}',
            breadcrumb: '{number}',
            offerSection: {
                title: 'Your personalised offer',
                body: 'By clicking on "Accept", you confirm the offer and finalise the binding order. If you select "Reject", you can tell us a reason or your change requests so that we can adjust the offer accordingly.',
                actions: {
                    approve: 'Accept',
                    reject: 'Reject',
                },
                approveDialog: {
                    title: 'Accept offer?',
                    body: 'By accepting this offer, you are placing a binding and chargeable order. Please check all details again before finalising your order.',
                    action: 'Accept with costs',
                    successMessage: 'Offer was accepted.',
                },
                rejectDialog: {
                    title: 'Reject offer?',
                    body: 'Please let us know why you reject the offer or what changes you would like to see. This will enable us to respond even better to your requirements.',
                    fieldLabel: 'Reason for the rejection',
                    fieldPlaceholder: 'I reject the offer because ...',
                    action: 'Reject definitively',
                    successMessage: 'Offer was rejected.',
                },
            },
            type: {
                s3: {
                    managementInterfaceSection: {
                        title: 'Management interface',
                        groupName: 'Group Name: Customers',
                        incompleteSetUp:
                            'Access to the management interface is not yet fully set up. Please contact our support team.',
                    },
                    endpointSection: {
                        title: 'S3 endpoints (via HTTP or HTTPS)',
                    },
                    pricingSection: {
                        title: 'Pricing',
                        storage: {
                            title: 'Storage',
                            description: 'per GB / per month',
                        },
                    },
                },
                cloud: {
                    managementInterfaceSection: {
                        title: 'Management interface',
                    },
                    pricingSection: {
                        title: 'Pricing',
                        titleWithDiscount:
                            'Pricing including {consumptionDiscountPercent}% discount',
                        highAvailability: {
                            title: 'High availability storage',
                            attributes: {
                                name: 'Name',
                                vCPU: 'vCPU (Cores)',
                                RAM: 'RAM (GB)',
                                storage: 'Storage (GB)',
                                iops: 'Max. IOPS',
                                price: 'Price per hour',
                            },
                        },
                        highIops: {
                            title: 'High IOPS',
                            attributes: {
                                name: '@:pages.OrderPage.type.cloud.pricingSection.highAvailability.attributes.name',
                                vCPU: '@:pages.OrderPage.type.cloud.pricingSection.highAvailability.attributes.vCPU',
                                RAM: '@:pages.OrderPage.type.cloud.pricingSection.highAvailability.attributes.RAM',
                                storage:
                                    '@:pages.OrderPage.type.cloud.pricingSection.highAvailability.attributes.storage',
                                iops: '@:pages.OrderPage.type.cloud.pricingSection.highAvailability.attributes.iops',
                                price: '@:pages.OrderPage.type.cloud.pricingSection.highAvailability.attributes.price',
                            },
                        },
                        blockStorage: {
                            title: 'Block storage',
                            description:
                                'Additional network storage that can be booked for your compute instances. Ideal for expanding capacity without changing existing systems.',
                            keyFact1: 'Network-attached NVMe storage with up to 2000 IOPS',
                            keyFact2: 'Up to 10 TB per volume',
                            keyFact3: 'Price: {price} per GB per hour',
                        },
                    },
                },
                backup: {
                    managementInterfaceSection: {
                        title: 'Management interface',
                        incompleteSetUp:
                            'Access to the management interface is not yet fully set up. Please contact our support team.',
                    },
                    endpointSection: {
                        title: 'Backup endpoint (via HTTP or HTTPS)',
                    },
                    pricingSection: {
                        title: 'Pricing',
                        titleWithDiscount:
                            'Pricing including {consumptionDiscountPercent}% discount',
                        storage: {
                            title: 'Storage',
                            description: 'per TB / per month',
                        },
                        device: {
                            title: 'Device',
                            description: 'per Device / per month',
                        },
                        booster: {
                            title: 'Booster',
                            hint: 'MongoDB oder Microsoft SQL',
                            description: 'per month',
                        },
                    },
                },
            },
        },
        IpUsageIndexPage: {
            title: 'IPAM',
            breadcrumb: '@:pages.IpUsageIndexPage.title',
        },
        IpUsageNetworkPage: {
            title: 'IP network',
            breadcrumb: 'IP network',
        },
        OrderWanPage: {
            title: 'WAN-Traffic',
            breadcrumb: '@:pages.OrderWanPage.title',
        },
        OrderLanPage: {
            title: 'LAN-Traffic',
            breadcrumb: '@:pages.OrderLanPage.title',
        },
        OrderPowerPage: {
            title: 'Power consumption',
            breadcrumb: '@:pages.OrderPowerPage.title',
        },
        DeviceUsageIndexPage: {
            title: 'Server',
            breadcrumb: '@:pages.DeviceUsageIndexPage.title',
        },
        DeviceUsagePage: {
            title: 'Server: {name}',
            breadcrumb: '{id}',
            temperaturesSection: {
                title: 'Temperatures',
            },
            hardwareSection: {
                title: 'Hardware',
            },
        },
        RentUsageIndexPage: {
            title: 'Rentals',
            breadcrumb: '@:pages.RentUsageIndexPage.title',
        },
        ColocationUsageIndexPage: {
            title: 'Colocation',
            subItem: 'Overview',
            breadcrumb: '@:pages.ColocationUsageIndexPage.title',
        },
        InvoiceIndexPage: {
            title: 'Invoices',
            breadcrumb: '@:pages.InvoiceIndexPage.title',
            badge: {
                description: 'There is {count} open invoice | There are {count} open invoices',
            },
        },
        InvoicePaymentPage: {
            title: 'Pay invoice',
            breadcrumb: '{number}',
            paymentMethod: {
                title: 'Payment method',
            },
            summary: {
                title: 'Invoice details',
            },
            security: {
                title: 'Secure payment',
                enum: {
                    ssl: '256-Bit SSL encryption',
                    compliant: 'PCI DSS compliant',
                    stripe: 'Powered by Stripe',
                },
            },
            help: {
                title: 'Need help?',
                description:
                    'If you have any questions about your payment, please contact our support.',
            },
        },
        InvoicePaymentSuccessPage: {
            title: 'Invoice paid',
            breadcrumb: '{number}',
            paymentForm: {
                initializing: 'Initializing payment form...',
                pleaseWait: 'Please wait while we set up your secure payment form',
                processingPayment: 'Processing payment...',
                paymentFailed: 'Payment failed',
                stripeInitializationFailed: 'Error initializing payment form',
            },
            thankYouSection: {
                title: 'Payment successful!',
                description:
                    'Your payment has been processed successfully. You will receive a confirmation mail shortly.',
                note: 'Thank you for your trust!',
                viewInvoices: 'View invoices',
            },
        },
        TicketIndexPage: {
            title: 'Tickets',
            breadcrumb: '@:pages.TicketIndexPage.title',
        },
        SettingsAccountPage: {
            title: 'Settings',
            breadcrumb: '@:pages.SettingsAccountPage.title',
            navigation: {
                account: 'Login',
                notifications: 'Notifications',
                api: 'API',
            },
            twoFactorAuthenticationDialog: {
                title: 'Activate two factor authentication',
                step1Label: 'Scan QR code',
                step1Description:
                    'Use an authentication app such as <a target="_blank" class="text-blue-700 hover:text-blue-600 hover:underline cursor-pointer" href="https://authy.com/"> Authy </a>, <a target="_blank" class="text-blue-700 hover:text-blue-600 hover:underline cursor-pointer" href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=de&gl=US"> Google Authenticator </a> or a browser extension such as <a target="_blank" class="text-blue-700 hover:text-blue-600 hover:underline cursor-pointer" href="https://1password.com/downloads/browser-extension/">1Password</a> to scan.',
                confirmationCodeField: 'Confirmation code',
                step2Label: 'Enter confirmation code',
                step2Description: 'Enter the code from the authentication app for confirmation.',
                step3Label: 'Save recovery codes',
                step3Description:
                    'Save your recovery codes in a safe place so that you can regain access to your account if you lose your authentication app.',
            },
        },
        NewsPostIndexPage: {
            title: 'News',
            breadcrumb: '@:pages.NewsPostIndexPage.title',
        },
        TicketPage: {
            breadcrumb: '{id}',
            ticketCreated: 'created @:resources.ticket.name',
            deletedUser: 'Deleted user',
            commented: 'commented',
            avatarAlt: 'Avatar of {name}',
            ticketSolved: 'Ticket solved.',
            ticketSolvedAlert:
                'This ticket has already been solved and can no longer be processed.',
        },
        DatacenterVisitIndexPage: {
            title: 'Datacenter Accesses',
            subItem: 'Access',
            breadcrumb: 'Datacenter Access',
            drawer: {
                title: 'Visit Details',
            },
            actions: {
                createNewVisit: 'Datacenter registration',
            },
        },
        DatacenterVisitWizardPage: {
            title: 'Datacenter Visit',
            headline: 'Register a datacenter visit',
            ticket: {
                subjectPrefix: 'Datacenter Access Request',
                subjectPrefixNoc: 'Datacenter Access Request (Emergency Support) ',
                creationError: 'Error creating ticket. Please try again.',
                creating: 'Creating ticket...',
            },
        },
        InboxPage: {
            title: 'Inbox',
            breadcrumb: 'Inbox',
            selectAll: 'Select all',
            selectAllPages: 'Select all pages',
            filters: {
                all: 'All',
                unread: 'Unread',
                protect: '@:pages.AttackIndexPage.title',
                byType: 'By Type',
                attachments: 'Attachments',
            },
            bulkActions: {
                selected: '{count} selected',
                markRead: 'Mark as read',
                markUnread: 'Mark as unread',
                confirmDelete:
                    'Are you sure you want to delete this notification? | Are you sure you want to delete {count} notifications?',
                success: {
                    delete: 'Notifications deleted',
                },
            },
            actions: {
                markRead: 'Mark as read',
                markUnread: 'Mark as unread',
                unsubscribe: 'Unsubscribe',
            },
            emptyState: {
                title: 'No notifications',
                description: 'You have no notifications at the moment.',
            },
            confirmDelete: 'Are you sure you want to delete this notification?',
            success: {
                deleted: 'Notification deleted',
            },
        },
        AttackIndexPage: {
            title: 'Protect',
            breadcrumb: '@:pages.AttackIndexPage.title',
            trafficSection: {
                title: 'Monitored Total Traffic',
            },
            attacksSection: {
                title: 'DDOS Attacks',
            },
        },
        AttackPage: {
            title: 'DDoS attack',
            breadcrumb: 'DDoS attack',
            trafficSection: {
                title: 'Monitored IP Traffic',
            },
            attackDetailsSection: {
                title: 'Attack Details',
                sourceIp: 'Source IPs',
                sourceCountry: 'Source Countries',
                sourceAsn: 'Source ASNs',
                sourcePort: 'Source Ports',
                destinationPort: 'Destination Ports',
                packetLength: 'Packet Lengths',
                protocol: 'Protocols',
            },
        },
    },
    wizards: {
        datacenterVisit: {
            steps: {
                dateTime: {
                    progressbar: 'Date & Time',
                    title: 'Visit Period',
                    startDateLabel: 'Start date & time',
                    endDateLabel: 'End date & time',
                    alerts: {
                        sla: 'Please note that our datacenter team needs at least 4 hours (within business hours) to process your request and book your visit.',
                        noc: {
                            requiredDescription:
                                'Due to the following reasons, an emergency support ticket will be created automatically:',
                            reasons: {
                                holiday: 'Request on a holiday',
                                weekend: 'Request on a weekend',
                                outsideBusinessHours: 'Request outside of our business hours',
                            },
                        },
                        businessHoursTitle: 'Our business hours:',
                    },
                },
                visitors: {
                    title: 'Who should be registered?',
                    contacts: {
                        progressbar: 'Internal Visitors',
                        selectUsersLabel: 'Company employees',
                        selectUserPlaceholder: 'Select a contact',
                        loadingContacts: 'Loading contacts...',
                        noContactsAvailable: 'No contacts available',
                        userNameLabel: 'Me',
                        passportNamePlaceholder: 'Name according to ID',
                        visitorCount: 'Total number of visitors: {count} of max. {max}',
                        alerts: {
                            passportName: {
                                match: 'The names provided must exactly match those on your ID document. ',
                                deviations:
                                    'If there are any discrepancies, please enter your full name as it appears on your ID in the free-text fields.',
                            },
                        },
                    },
                    guests: {
                        progressbar: 'External Visitors',
                        label: 'Company guests',
                        guestNamePlaceholder: 'Name as shown on ID',
                        passportDialog: {
                            title: 'ID Document Confirmation',
                            message:
                                'Please confirm that all entered names exactly match the respective ID document. This is required for datacenter access.',
                        },
                    },
                    actions: {
                        addGuest: 'Add visitor',
                        addSelfAsVisitor: 'Add myself as a visitor',
                    },
                    validation: {
                        noVisitorsSelected: 'Please register at least one visitor.',
                        userNameValidationError:
                            'The name must contain parts of your original name',
                    },
                },
                rackAccess: {
                    progressbar: 'Rack Access',
                    title: 'Rack access',
                    rackAccessLabel: 'To which racks should access be granted?',
                    unlockRackLabel: 'The datacenter team will unlock the rack.',
                    validation: {
                        selectAtLeastOneRack: 'Please select at least one rack.',
                    },
                    alerts: {
                        extraCostDetails: {
                            title: 'Additional costs may incur',
                            warning:
                                'Some racks may incur additional costs if they need to be opened by our team.',
                            checkSelf:
                                'Please check in advance whether you have your own rack key.',
                        },
                    },
                },
                message: {
                    progressbar: 'Your Message',
                    title: 'Your message to us',
                    additionalInfoLabel: 'Your message to us',
                },
                summary: {
                    progressbar: 'Summary',
                    title: 'Review your details',
                    detailsTitle: 'Details',
                    visitDate: 'Visit',
                    visitFrom: 'From',
                    visitTo: 'to',
                    visitors: 'Visitors',
                    selectedRacks: 'Rack access',
                    needsUnlocking: ' (The datacenter team will unlock the rack)',
                    nocTicket: 'Emergency Support',
                    termsLabel:
                        'I acknowledge that my request will first be reviewed and that the datacenter visit will only be considered confirmed after separate approval by 23M.',
                    actions: {
                        submitVisit: 'Register Visit',
                    },
                },
                thanksCard: {
                    title: 'Thank you for your request.',
                    message:
                        'Your request has been submitted successfully and will be processed as quickly as possible. You will shortly receive a separate confirmation mail regarding your visit. <br />  ' +
                        '<br /> In the meantime, you can either sit back and relax or return directly to our services.',
                    teamPrefix: 'Your',
                    teamSuffix: '-Team',
                },
            },
        },
    },
    resources: {
        address: {
            name: 'Address | Addresses',
            attributes: {
                street: 'Street',
                number: 'House number',
                zip: 'Zip code',
                city: 'City',
                additional: 'Additional',
                country: 'Country',
            },
            emptyState: {
                title: 'Create @.lower:resources.address.name',
            },
            emptyStateNoPermission: {
                title: 'No @.lower:resources.address.name found',
            },
        },
        country: {
            name: 'Land | Länder',
            attributes: {
                code: 'Ländercode',
                name: 'Name',
            },
        },
        bankAccount: {
            name: 'Bank account | Bank accounts',
            emptyState: {
                title: 'Create  @.lower:resources.bankAccount.name',
                body: 'Contact our support and create your @.lower:resources.bankAccount.name',
                mailSubject: '[23M.com] Create bank account ({customerNumber})',
                mailBody:
                    'Hello 23M-Support-Team %0D%0A%0D%0A I would like to create the following bank account...',
            },
        },
        contact: {
            name: 'Contact person | Contact persons',
            attributes: {
                name: 'Name',
                contactData: 'Contact data',
                email: 'Mail',
                phone: 'Phone',
                mobile: 'Mobile',
                roles: 'Roles',
                permissions: 'Permissions',
            },
            enums: {
                roles: {
                    owner: 'Owner',
                    admin: 'Admin',
                    technician: 'Technician',
                    accountant: 'Accountant',
                },
                permissions: {
                    can_manage_contacts: {
                        name: 'Manage contacts',
                        description:
                            'Can create, edit, deactivate, activate contacts and create logins.',
                    },
                    can_manage_customer: {
                        name: 'Manage customer data',
                        description: 'Can edit invoice mail and address',
                    },
                    can_access_receipts: {
                        name: 'Access invoices',
                        description: '',
                    },
                    can_access_services: {
                        name: 'Access services',
                        description: '',
                    },
                    can_book_datacenter_visit_for_self: {
                        name: 'Book datacenter visit for self',
                        description: '',
                    },
                    can_book_datacenter_visit_for_others: {
                        name: 'Book datacenter visit for colleagues and guests',
                        description: '',
                    },
                    can_see_all_datacenter_visits: {
                        name: 'See all datacenter visits',
                        description: 'Can see appointed datacenter visits from all employees',
                    },
                },
            },
            actions: {
                add: 'Add @.lower:resources.contact.name',
                addRole: {
                    error: 'Role could not be added.',
                },
                removeRole: {
                    error: 'Role could not be removed.',
                },
                addPermission: {
                    error: 'Permission could not be added.',
                },
                removePermission: {
                    error: 'Permission could not be removed.',
                },
            },
            emptyState: {
                title: 'Create @.lower:resources.contact.name',
            },
            messages: {
                canNotDeleteYourself: "You can't delete yourself.",
                deactivateConfirmation:
                    'Do you really want to deactivate this @.lower:resources.contact.name ?',
            },
        },
        customer: {
            name: 'Customer',
            attributes: {
                number: 'Customer',
                name: 'Name',
                vat_id: 'VAT id',
                payment_type: 'Payment method',
                payment_due_days: 'Payment term',
                receipt_mail_address: 'Invoice mail',
            },
            enums: {
                payment_type: {
                    bank_transfer: 'Bank transfer',
                    direct_debit: 'Direct debit',
                    paypal: 'Paypal',
                },
            },
            receiptMailAddressEmptyState: {
                title: 'Create @.lower:resources.customer.attributes.receipt_mail_address',
            },
            receiptMailAddressEmptyStateNoPermission: {
                title: 'No @.lower:resources.customer.attributes.receipt_mail_address found',
            },
        },
        user: {
            name: 'User',
            nameAlternative: 'Login',
            attributes: {
                name: 'Name',
                password: 'Password',
                recovery_codes: 'Recovery codes',
            },
            actions: {
                createAccount: {
                    label: 'Create  @.lower:resources.user.nameAlternative',
                    hint: 'A login will be created based on the contact information and an invitation mail will be sent.',
                },
                confirmPassword: 'Confirm password',
                activateTwoFactorAuthentication: {
                    successMessage: 'Two factor authentication activated',
                },
                deactivateTwoFactorAuthentication: {
                    successMessage: 'Two factor authentication deactivated',
                },
                addNotificationType: {
                    error: 'Notification type could not be added.',
                },
                removeNotificationType: {
                    error: 'Notification type could not be removed.',
                },
            },
            enums: {
                notificationTypes: {
                    miscellaneous: 'Miscellaneous',
                    maintenance: 'Maintenance',
                    price_list: 'Price list',
                    outage: 'Outage',
                    order_start: 'Order start',
                    cancelation: 'Cancelation',
                    order_approved_by_customer: 'Order approved',
                    attack_started: 'Attack started',
                    attack_ended: 'Attack ended',
                },
            },
        },
        inboxNotification: {
            name: 'Notification',
            enums: {
                status: {
                    unread: 'Unread',
                    read: 'Read',
                },
                type: {
                    miscellaneous: 'Miscellaneous',
                    maintenance: 'Maintenance',
                    price_list: 'Price List',
                    outage: 'Outage',
                    order_start: 'Order Start',
                    cancelation: 'Cancelation',
                    order_approved_by_customer: 'Order Approved',
                    receipt: 'Invoice',
                    invoice_paid: 'Payment',
                    attack_started: '@:pages.AttackIndexPage.title',
                    attack_ended: '@:pages.AttackIndexPage.title',
                },
            },
            notificationContent: {
                greetings: 'Kind regards',
                team: 'Your 23M-Team',
            },
            attributes: {
                checkbox: '',
                subject: 'Subject',
                content: 'Content',
                type: 'Type',
                created_at: 'Received at',
                read_at: 'Read at',
                attachments: 'Attachments',
            },
        },
        order: {
            name: 'Order',
            attributes: {
                number: 'Order',
                customer_reference: 'Reference',
                status: 'Status',
                type: 'Order type',
                completed_at: 'Completed at',
                approved_at: 'Approved at',
                planned_start_at: 'Planned to',
                start_at: 'Start date',
                end_at: 'Terminated at',
                setup_price: 'NRC',
                monthly_price: 'MRC',
                price: 'Price',
                cancelation_period: 'Cancellation period',
                extension_period: 'Extension',
                min_order_duration: 'Minimum duration',
            },
            enums: {
                status: {
                    draft: 'Draft',
                    completed: 'Offer',
                    approved_by_customer: 'Approved by customer',
                    approved: 'Approved',
                    due: 'Due',
                    active: 'Active',
                    canceled: 'Terminated',
                    terminated: 'Terminated',
                    rejected: 'Rejected',
                },
                decoratedStatus: {
                    startAt: 'Starting on: {date}',
                    startsShortly: 'Starting shortly',
                    endAt: 'Terminated on {date}',
                },
                type: {
                    dedicated: 'Dedicated Server',
                    rent: 'Rent',
                    colocation: 'Colocation',
                    service: 'Service',
                    cloudserver: 'Cloud Server',
                    cloud: 'Cloud',
                    ip: 'Ip',
                    s3: 'S3 Object Storage',
                    domain_robot: 'Domain',
                    network: 'Network',
                    backup: 'Backup',
                },
            },
            actions: {
                createCustomerReference: 'Create Reference',
                editCustomerReference: 'Edit Reference',
            },
            ticket: {
                subject: '[@:resources.order.name {orderNumber}] ',
            },
        },
        orderItem: {
            name: 'Order item | Order items',
            attributes: {
                category: 'Category',
                type: 'Type',
                description: 'Description',
            },
            enums: {
                category: {
                    device: 'Hardware',
                    ram: 'RAM',
                    storage: 'Storage',
                    gpu: 'GPU',
                    network: 'Network',
                    service: 'Service',
                    ip: 'IP address | IP addresses',
                    s3: 'S3 Object Storage',
                    power: 'Power',
                    unknown: 'Unknown',
                    vpn: 'VPN',
                    peripheral: 'Accessory',
                },
            },
            actions: {
                ipmiRequest: 'Show IPMI',
                showLanTrafficGraph: 'LAN traffic',
            },
            errors: {
                ipmiRequest: 'An error occurred during the IPMI query. Please try again later.',
            },
        },
        ipUsageAddress: {
            name: '',
            attributes: {
                ip: 'IP address | IP addresses',
                order_number: '@:resources.order.name',
                dns_name: 'rDNS name',
                customer_reference: 'Reference',
                ddos: 'DDoS attacks',
            },
        },
        ipUsageNetwork: {
            name: '',
            attributes: {
                ip: 'IP network | IP networks',
                order_number: '@:resources.order.name',
                network_ips: 'rDNS entries',
                has_dns_management: '@:resources.ipUsageAddress.attributes.has_dns_management',
                customer_reference: '@:resources.ipUsageAddress.attributes.customer_reference',
            },
        },
        networkIp: {
            name: '',
            attributes: {
                ip: 'IP address | IP addresses',
                mask: 'Subnet mask',
                dns_name: 'rDNS Name',
            },
        },
        vpnIpUsage: {
            name: 'VPN',
            attributes: {
                ip: 'IP address | IP addresses',
                order_number: '@:resources.order.name',
            },
        },
        deviceUsage: {
            name: 'Server | Servers',
            attributes: {
                device_unit_name: 'Server',
                device_unit_old_name: 'Legacy name',
                device_name: 'Type',
                cpu: 'CPU',
                order_number: 'Order',
                customer_reference: '@:resources.ipUsageAddress.attributes.customer_reference',
                device_unit_component_unit_descriptions: 'Components',
                device_unit_netbox_item_rack_name: 'Rack',
                device_unit_netbox_item_rack_room: 'Room',
            },
            actions: {
                createCustomerReference:
                    'Create @.lower:resources.deviceUsage.attributes.customer_reference',
                editCustomerReference:
                    'Edit @.lower:resources.deviceUsage.attributes.customer_reference ',
            },
            ticket: {
                subject: '[@:resources.deviceUsage.name {name}] ',
            },
            messages: {
                hardwareManagementUnavailable: {
                    title: 'System information not available',
                    description:
                        'There are no system information available for this server. Please <a href="#" class="underline cursor-pointer">contact our support</a>.',
                },
                hardwareManagementUnauthorized: {
                    title: 'No permission for this server',
                    description:
                        'There are no permissions for this server. Please <a href="#" class="underline cursor-pointer">contact our support</a>.',
                },
                hardwareManagementError: {
                    title: 'Error fetching system information',
                    description:
                        'An error occurred. Please <a href="#" class="underline cursor-pointer">contact our support</a>.',
                },
            },
        },
        deviceUsageHardwareManagement: {
            name: 'System | Systems',
            attributes: {
                manufacturer: 'Manufacturer',
                model: 'Model',
                serial_number: 'Serial Number',
                status_health: 'Health Status',
                power_state: 'Power State',
                bios_version: 'BIOS Version',
                indicator_led: 'Indicator LED',
                status_state: 'Status',
                memory_health: 'Memory Health',
                processor_health: 'Processor Health',
                name: 'Name',
            },
            enums: {
                health_state: {
                    ok: 'OK',
                    warning: 'Warning',
                    critical: 'Critical',
                    unknown: 'Unknown',
                },
                power_state: {
                    on: 'On',
                    off: 'Off',
                    powering_on: 'Powering on',
                    powering_off: 'Powering off',
                    paused: 'Stopped',
                },
                state: {
                    enabled: 'Enabled',
                    disabled: 'Disabled',
                    offline: 'Offline',
                    absent: 'Absent',
                    starting: 'Starting',
                    unavailable_offline: 'Unavailable offline',
                },
                indicator_led_state: {
                    lit: 'On',
                    off: 'Off',
                    blinking: 'Blinking',
                },
                physical_context: {
                    Room: 'Room',
                    Intake: 'Intake',
                    Exhaust: 'Exhaust',
                    LiquidInlet: 'Liquid inlet',
                    LiquidOutlet: 'Liquid outlet',
                    Front: 'Front',
                    Back: 'Back',
                    Upper: 'Upper',
                    Lower: 'Lower',
                    Left: 'Left',
                    Right: 'Right',
                    Chassis: 'Chassis',
                    Backplane: 'Backplane',
                    SystemBoard: 'System board',
                    PowerSupply: 'Power supply',
                    VoltageRegulator: 'Voltage regulator',
                    Rectifier: 'Rectifier',
                    Transformer: 'Transformer',
                    ACInput: 'AC input',
                    ACOutput: 'AC output',
                    DCBus: 'DC bus',
                    PowerSubsystem: 'Power subsystem',
                    CPU: 'CPU',
                    CPUSubsystem: 'CPU subsystem',
                    Memory: 'RAM',
                    MemorySubsystem: 'RAM subsystem',
                    GPU: 'GPU',
                    GPUSubsystem: 'GPU subsystem',
                    ASIC: 'ASIC',
                    FPGA: 'FPGA',
                    Accelerator: 'Accelerator',
                    StorageDevice: 'Storage',
                    NetworkingDevice: 'Network',
                    Transceiver: 'Transceiver',
                    ComputeBay: 'Compute bay',
                    StorageBay: 'Storage bay',
                    NetworkBay: 'Network bay',
                    ExpansionBay: 'Expansion bay',
                    Fan: 'Fan',
                    Blade: 'Blade',
                    Module: 'Module',
                },
                power_state_action: {
                    On: 'Power On',
                    ForceOff: 'Force Off',
                    ForceOn: 'Force On',
                    ForceRestart: 'Force Reboot',
                    GracefulShutdown: 'Graceful Shutdown',
                    GracefulRestart: 'Graceful Reboot',
                    PushPowerButton: 'Power Button',
                    Nmi: 'Trigger NMI',
                    PowerCycle: 'Power Cycle',
                },
            },
        },
        rentUsage: {
            name: 'Rental | Rentals',
            attributes: {
                device_unit_name: 'Rental',
                device_name: '@:resources.deviceUsage.attributes.device_name',
                order_number: '@:resources.deviceUsage.attributes.order_number',
                device_unit_serial: 'Serial',
                device_type: 'Device type',
            },
            ticket: {
                subject: '[@:resources.rentUsage.name {name}] ',
            },
        },
        colocationUsage: {
            name: '',
            attributes: {
                id: 'ID',
                rack_name: 'Rack',
                rack_room: 'Room',
                order_number: '@:resources.order.name',
                order_colocation_item_customer_reference:
                    '@:resources.ipUsageAddress.attributes.customer_reference',
                order_colocation_item_colocation_name: 'Product',
                order_colocation_item_order_feed_item_current_power_consumption:
                    'Power consumption',
            },
            actions: {
                createCustomerReference:
                    'Create @.lower:resources.colocationUsage.attributes.order_colocation_item_customer_reference',
                editCustomerReference:
                    'Edit @.lower:resources.colocationUsage.attributes.order_colocation_item_customer_reference',
            },
            ticket: {
                subject: '[@:resources.order.name {name}] ',
            },
        },
        orderTrafficItem: {
            name: 'Traffic',
            attributes: {
                pricePerUnit: 'Per additional {unit} {price}',
            },
            actions: {
                showWanTrafficGraph: 'WAN traffic',
            },
        },
        orderS3Item: {
            name: 'S3 Object Storage',
            attributes: {
                username: 'User ID',
                pricing: '{pricePerUnit} per GB / per month',
            },
            actions: {
                managementInterface: 'Open',
            },
        },
        orderCloudItem: {
            name: 'Cloud',
            attributes: {
                account_name: 'Username',
                password: 'Password',
                domain_name: 'Domain',
            },
            actions: {
                openManagementInterface: 'Open',
                requestPassword: {
                    label: 'Request password',
                    confirm: 'Request password once',
                    hint: 'As your security is important to us, you can only request your password once. Please keep it safe (e.g. in a password manager). If you have any problems, our support team will be happy to help.',
                    success: 'Password successfully requested',
                    disabled: 'Has already been requested',
                },
            },
        },
        orderIpItem: {
            name: 'IP addresses',
        },
        orderDomainItem: {
            name: 'Domain Services',
            attributes: {
                domain_username: 'Username',
            },
            actions: {
                openDomainRobot: 'Open domain robot',
            },
        },
        orderBackupItem: {
            name: 'Backup',
            attributes: {
                storage_pricing: 'Storage: {price} per TB / per month',
                device_pricing: 'Devices: {price} per Device / per month',
                user_id: 'User ID',
                password: 'Password',
            },
            actions: {
                open: 'Open',
                requestPassword: {
                    label: 'Request password',
                    confirm: 'Request password once',
                    hint: 'As your security is important to us, you can only request your password once. Please keep it safe (e.g. in a password manager). If you have any problems, our support team will be happy to help.',
                    success: 'Password successfully requested',
                    disabled: 'Has already been requested',
                },
            },
        },
        orderFeedItem: {
            attributes: {
                fuse_protection: 'Protection per feed {fuseProtection} A',
            },
        },
        orderPowerItem: {
            pricing: '{pricePerUnit} per kWh',
        },
        orderColocationItem: {
            attributes: {
                rack_name: 'Rack',
            },
        },
        orderCloudserverItem: {
            name: 'Cloud Server',
        },
        orderLockerItem: {
            name: 'Locker',
            attributes: {
                locker_room: 'Room',
                locker_name: 'Cabinet',
                compartment: 'Compartment',
            },
        },
        orderVpnItem: {
            name: '{ count } { type } | { count } { type }s',
        },
        orderCrossConnectItem: {
            name: 'Cross Connect',
            attributes: {
                type: 'Type',
                usage_interface_name: 'Name',
                netbox_cross_connect_name: 'Identifier',
                netbox_rack_name: 'Rack',
                netbox_rack_room: 'Room',
                connected_item_order_number: 'Connected Order',
            },
        },
        invoice: {
            name: 'Invoice | Invoices',
            attributes: {
                number: 'Invoice',
                status: 'Status',
                date: 'Invoice date',
                due_on: 'Due date',
                total_net: 'Net',
                total_gross: 'Gross',
            },
            enums: {
                status: {
                    open: 'Open',
                    paid: 'Paid',
                },
            },
        },
        ticket: {
            name: 'Ticket | Tickets',
            attributes: {
                subject: 'Subject',
                id: 'ID',
                number: 'Ticket',
                created_at: 'Created',
                updated_at: 'Last activity',
                status: 'Status',
                topic: 'Topic',
                description: 'Description',
            },
            enums: {
                status: {
                    open: 'Open',
                    pending: 'Waiting for information',
                    solved: 'Resolved',
                    closed: 'Closed',
                },
                statusHint: {
                    open: 'This ticket is currently being processed.',
                    pending: 'Additional information is required for this ticket.',
                    solved: 'This ticket has been resolved. Further comments can be added for up to 90 days.',
                    closed: 'This ticket has been closed. Further comments are no longer possible. Please create a new ticket instead.',
                },
                topic: {
                    sales: 'Product or quotation enquiry',
                    finance: 'Question about a settlement',
                    technic: 'Technical support (during business hours)',
                    emergency: 'Technical emergency (outside business hours)',
                    miscellaneous: 'Miscellaneous',
                    datacenterAccess: 'Datacenter Access (during business hours)',
                    datacenterAccessEmergency: 'Emergency Datacenter Access (NOC)',
                },
            },
            actions: {
                selectStatus: 'Any',
                create: 'Create @:resources.ticket.name',
            },
        },
        ticketComment: {
            name: 'Comment | Comments',
        },
        attack: {
            name: 'DDoS attack | DDoS attacks',
            attributes: {
                attack_id: 'DDoS attack',
                ip_address: 'IP address',
                status: 'Status',
                date: 'Date',
                duration: 'Duration',
                time: ' @:resources.attack.attributes.date / @:resources.attack.attributes.duration',
                peak: 'Peak ',
                volume: 'Volume',
                dimension:
                    ' @:resources.attack.attributes.peak / @:resources.attack.attributes.volume',
                description: 'Description',
            },
            enums: {
                status: {
                    start: 'Start',
                    ongoing: 'Ongoing',
                    end: 'End',
                },
            },
            filters: {
                timeRange: {
                    label: 'Time range',
                },
            },
        },
        attackTrafficDataPoint: {
            name: 'Traffic Data Point | Traffic Data Points',
            attributes: {
                date: 'Date & Time',
                allowedTraffic: 'Allowed Traffic',
                blockedTraffic: 'Blocked Traffic',
            },
        },
        datacenterVisit: {
            attributes: {
                contact_id: 'Applicant',
                created_at: 'Application Date',
                visit_start: 'Visit Start',
                visit_end: 'Visit End',
                visit: 'Visit',
                visitors: 'Visitors',
                racks: 'Racks',
                notes: 'Your Message To Us',
                is_noc: 'Emergency Support',
                ticket_number: 'Ticket',
                ticket_status: 'Status',
            },
        },
    },
    messages: {
        info: {
            newOffer: 'You have a new offer',
            empty: 'No data found',
        },
        success: {
            saved: 'Saved successfully',
            deleted: 'Deleted successfully',
        },
        confirm: {
            delete: 'Are you sure you want to delete this reference?',
        },
        thanks: {
            title: 'Thank you for your trust',
            description: 'We will start with the implementation immediately.',
        },
        errors: {
            attachmentInvalidType:
                'At least one attachment has an invalid file type. Allowed formats: PDF, JPG, PNG, GIF, WebP, TXT, CSV, DOC, DOCX, XLS, XLSX.',
            ticketNotCreated: 'No @:resources.ticket.name was created. Please check the form.',
            ticketCommentNotCreated:
                'No @:resources.ticketComment.name was created. Please check the form.',
        },
    },
    forms: {
        optional: 'Optional',
        addressDach: {
            street: {
                label: 'Street',
                placeholder: '',
            },
            number: {
                label: 'House number',
                placeholder: '',
            },
            country: {
                label: 'Country',
            },
            zip: {
                label: 'Zip code',
                placeholder: '',
            },
            city: {
                label: 'City',
                placeholder: '',
            },
            additional: {
                label: 'Additional',
                placeholder: '',
            },
        },
        addressNonDach: {
            street: {
                label: 'Street & house number',
                placeholder: '',
            },
            country: {
                label: 'Country',
            },
            city: {
                label: 'Zip code & city',
                placeholder: '',
            },
            additional: {
                label: 'Additional',
                placeholder: '',
            },
        },
        contact: {
            title: {
                label: 'Title',
                placeholder: '',
            },
            first_name: {
                label: 'First name',
                placeholder: '',
            },
            last_name: {
                label: 'Last name',
                placeholder: '',
            },
            gender: {
                label: 'Salutation',
                options: {
                    male: 'Mr.',
                    female: 'Mrs.',
                    diverse: 'Divers',
                    not_specified: 'Prefer not to say',
                },
            },
            email: {
                label: 'Mail',
                placeholder: '',
            },
            phone: {
                label: 'Phone',
                placeholder: '',
            },
            mobile: {
                label: 'Mobile',
                placeholder: '',
            },
        },
        updateUserPassword: {
            title: 'Change password',
            description: 'Update your password associated with your account.',
            password_current: {
                label: 'Current password',
                placeholder: '',
            },
            password: {
                label: 'New password',
                placeholder: '',
            },
            password_confirmation: {
                label: 'Confirm password',
                placeholder: '',
            },
        },
        twoFactorAuthentication: {
            title: 'Two factor authentication',
            description: 'Increase the security of your account with two factor authentication.',
            has_two_factor_authentication: {
                label: 'Authenticator app',
            },
            recovery_codes: {
                label: '@:resources.user.attributes.recovery_codes',
            },
        },
        notificationType: {
            title: 'Notification Types',
            description:
                'Customize your notifications – so you always stay informed about exactly what matters to you.',
            groupSummary: '{enabled} of {total} enabled',
            columns: {
                type: 'Type',
                mail: '@:forms.notificationType.channelPreferences.mail',
                inbox: '@:forms.notificationType.channelPreferences.inbox',
            },
            miscellaneous: {
                label: '@:resources.user.enums.notificationTypes.miscellaneous',
                hint: 'General notices and information that do not belong to a specific category.',
            },
            maintenance: {
                label: '@:resources.user.enums.notificationTypes.maintenance',
                hint: 'Planned maintenance work that may affect your services – timely and transparent.',
            },
            price_list: {
                label: '@:resources.user.enums.notificationTypes.price_list',
                hint: 'Updates on our prices, tariff changes, or new offers.',
            },
            outage: {
                label: '@:resources.user.enums.notificationTypes.outage',
                hint: 'Important notifications about current disruptions and their resolution.',
            },
            cancelation: {
                label: '@:resources.user.enums.notificationTypes.cancelation',
                hint: 'Notifications about contract cancellations or upcoming terminations.',
            },
            order_start: {
                label: '@:resources.user.enums.notificationTypes.order_start',
                hint: 'Announcements regarding the commencement of orders and contract items.',
            },
            order_approved_by_customer: {
                label: '@:resources.user.enums.notificationTypes.order_approved_by_customer',
                hint: 'Announcements regarding the approval of orders.',
            },
            receipt: {
                label: '@:resources.user.enums.notificationTypes.receipt',
                hint: 'Outstanding invoices and payments.',
            },
            invoice_paid: {
                label: '@:resources.user.enums.notificationTypes.invoice_paid',
                hint: 'Notifications about paid invoices.',
            },
            attack_started: {
                label: '@:resources.user.enums.notificationTypes.attack_started',
                hint: 'Notifications when a DDoS attack on your IP addresses was identified.',
            },
            attack_ended: {
                label: '@:resources.user.enums.notificationTypes.attack_ended',
                hint: 'Notifications when an identified DDoS attack on your IP addresses has ended.',
            },
            channelPreferences: {
                mail: 'via Mail',
                inbox: 'via Inbox',
            },
            groups: {
                system: 'System & Status',
                orders: 'Orders',
                billing: 'Billing',
                protect: '@:pages.AttackIndexPage.title',
                other: 'Other',
            },
        },
        apiToken: {
            title: 'API Access',
            description: 'Manage your API tokens for accessing our interfaces.',
            token_name: {
                label: 'Token name',
                placeholder: 'e.g. My monitoring script',
            },
            token: {
                label: 'Your new token',
                description:
                    'Copy this token now and store it securely, ensuring it is inaccessible to third parties. For security reasons, it will be displayed to you only once.',
            },
            last_used_at: 'Last used',
            prefix: 'Prefix',
            noTokens: 'You have not created any API tokens yet.',
            create: 'Create token',
            edit: 'Edit token name',
            delete: 'Delete token',
            confirmDelete:
                'Do you really want to delete this token? Access with this token will be blocked immediately.',
            successCreated: 'Token created successfully.',
            successUpdated: 'Token name updated successfully.',
            successDeleted: 'Token deleted successfully.',
        },
        sendFeedback: {
            message: {
                label: 'Your message',
                placeholder: 'What would you like us to know?',
            },
            submit: 'Send feedback',
        },
        ticket: {
            topic: {
                label: '@:resources.ticket.attributes.topic',
                placeholder: 'Select a topic...',
            },
            subject: {
                label: '@:resources.ticket.attributes.subject',
            },
            description: {
                label: '@:resources.ticket.attributes.description',
            },
            uploads: {
                label: 'Attachments',
            },
            alerts: {
                info: {
                    question: 'Would you like to request a visit to our data center?',
                    link: 'Take advantage of our new registration process.',
                },
            },
        },
        ticketComment: {
            comment: {
                placeholder: 'Add a @.lower:resources.ticketComment.name ...',
            },
        },
    },
};
